import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Brand } from "@/components/Brand";
import { DisclosureFooter } from "@/components/FundingDisclosure";
import { LangToggle } from "@/pages/Legal";
import { useTour } from "@/components/tour/TourProvider";
import { useSpanishScreens } from "@/lib/i18n";
import { usePageMeta } from "@/lib/seo";
import { TopIndustries } from "@/components/funding/TopIndustries";

const META = { title: "Top Industries Getting Grant Funding Now | Federal, State & Local | GrantVerify", path: "/top-grant-industries",
  description: "The industries receiving the most small business and nonprofit grant money right now across federal, state, county and city programs, with example programs and typical award sizes. Updated monthly." };

export default function TopGrantIndustries() {
  const { lang } = useTour();
  useSpanishScreens(lang === "es");
  usePageMeta(META);
  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="top-industries-page">
      <header className="border-b border-slate-200"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex justify-between items-center gap-4"><Brand /><div className="flex items-center gap-3 sm:gap-5"><LangToggle /><Link to="/" className="text-sm text-slate-500 hover:text-slate-900 flex items-center gap-1" data-testid="top-industries-home-link"><ArrowLeft className="h-4 w-4" /><span className="hidden sm:inline">Home</span></Link></div></div></header>
      <main className="flex-1 grid-bg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="eyebrow mb-3">Grant funding trends</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 max-w-4xl" data-testid="top-industries-title">Where grant money is going right now</h1>
          <div className="mt-10"><TopIndustries /></div>
          <div className="mt-14 bg-slate-900 text-white rounded-lg p-8 flex flex-col md:flex-row md:items-center gap-4 justify-between" data-testid="top-industries-cta">
            <div><div className="font-display text-2xl font-bold">Is your business in one of these industries?</div><p className="text-slate-300 mt-1">Get a free eligibility check and see the exact grants, licenses and steps for your state and city.</p></div>
            <Link to="/login?mode=register" className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold px-6 py-3 rounded-md transition-colors shrink-0" data-testid="top-industries-signup-link">Start free <ArrowRight className="h-4 w-4" /></Link>
          </div>
        </div>
      </main>
      <DisclosureFooter />
    </div>
  );
}
